import { render, staticRenderFns } from "./PagingCustom.vue?vue&type=template&id=2ef60a8b&scoped=true"
import script from "./PagingCustom.vue?vue&type=script&lang=js"
export * from "./PagingCustom.vue?vue&type=script&lang=js"
import style0 from "./PagingCustom.vue?vue&type=style&index=0&id=2ef60a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef60a8b",
  null
  
)

export default component.exports